<template>
  <div class="wrapper">
    <base-bread-crumb :currBreadCrumb="currBreadCrumb"></base-bread-crumb>
    <div class="ccui-app-container">
      <!--高级搜索Begin-->
      <div class="ccui-advanced-search-wrapper ccui-clearfix">
        <el-search
          ref="elSearch"
          width="460px"
          :formProp="formData"
          @search="search"
          :isShowSearch="true"
          class="ccui-highsearch no-print"
        >
          <template slot="search">
            <el-date-picker
              v-model="formData.publishTime"
              searchLabel="发布时间"
              clearable
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
            >
            </el-date-picker>
            <el-input
              v-model.trim="formData.noticeTitle"
              clearable
              searchLabel="标题"
              placeholder="请输入标题模糊查询"
            ></el-input>
          </template>
          <el-date-picker
            v-model="formData.publishTime"
            searchLabel="发布时间"
            clearable
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            slot="searchItem1"
          >
          </el-date-picker>
          <el-input
            v-model.trim="formData.noticeTitle"
            clearable
            searchLabel="标题"
            placeholder="请输入标题模糊查询"
            slot="searchItem2"
          ></el-input>
        </el-search>
      </div>
      <!--高级搜索End-->
      <!--table表格区域Begin-->
      <div class="ccui-multifunctional-table-wrapper">
        <listBaseTable
          :tableName="tableName"
          :showCheckBox="false"
          :showOp="false"
          :data="tableData"
          :cellStyle="cellStyle"
          :pageNo.sync="pageNo"
          :pageSize.sync="pageSize"
          :pageTotal="pageTotal"
          :fixedTableThead="fixedTableThead"
          :unfixedTableThead="unfixedTableThead"
          border
          @handleList="handleList"
          @select-all="handleCheckAllChange"
          @select="handleCheckChange"
          @selection-change="handleSelectionChange"
        >
          <!--列表中的插槽Begin-->
          <template slot="title" slot-scope="{ row }">
            <el-button
              class="column-btn-ellipsis"
              size="mini"
              type="text"
              @click="check(row)"
            >
              {{ row[title] }}
            </el-button>
          </template>
          <!--列表中的插槽End-->
        </listBaseTable>
      </div>
      <!--table表格区域End-->
    </div>
  </div>
</template>

<script>
import { mixinListCommon } from "@/mixins/mixin-common/mixin-list";
import { commonTableWidth } from "@/setting/setting";
import baseBreadCrumb from "@/app/shop/components/baseBreadCrumb.vue";
import { announcementPageSource } from "@/setting/setting";
import moment from "moment";
export default {
  name: "list",
  mixins: [mixinListCommon],
  components: {
    baseBreadCrumb
  },
  activated() {
    this.getNoticeList();
  },
  deactivated() {
    this.initData();
  },
  props: {
    currBreadCrumb: {
      type: Array,
      default: () => {
        return [];
      }
    },
    callInterface: {
      type: Function
    },
    rowsField: {
      type: String,
      default: "rows"
    },
    source: {
      //默认是通知公告
      type: String,
      default: announcementPageSource.notice
    },
    title: {
      type: String,
      default: "title"
    },
    activeIndex: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      tableName: this.tableList.viewMoreList, // 默认的tableName 工程中唯一
      isSelection: false,
      formData: {},
      formDataSearch: {},
      tableData: [],
      unfixedTableTheadAll: [],
      fixedTableThead: [],
      unfixedTableThead: Object.freeze([
        {
          label: "序号",
          prop: "id",
          type: "index",
          width: commonTableWidth.serialNoWidth,
          checked: true
        },
        {
          label: "标题",
          prop: "title",
          checked: true,
          // width: 500,
          slot: "title"
        },
        {
          label: "发布时间",
          prop: "publishTime",
          width: commonTableWidth.dateTimeWidth,
          checked: true
        }
      ]),
      pageNo: 1,
      pageSize: 10,
      pageTotal: 0,
      otherParams: {
        appId: 100125,
        module: 1,
        pageState: 2
      }
    };
  },
  methods: {
    initData() {
      this.pageNo = 1;
      this.pageSize = 10;
      this.pageTotal = 0;
      this.formData = {};
      this.formDataSearch = {};
      this.tableName = this.tableList.viewMoreList;
    },
    handleList() {
      // 分页操作列表
      this.getNoticeList();
    },
    getNoticeList() {
      let param = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        isShowPageLoading: true
      };
      if (
        this.formDataSearch.publishTime &&
        this.formDataSearch.publishTime.length !== 0
      ) {
        this.formDataSearch.noticeTimeStart = this.formDataSearch.publishTime[0];
        this.formDataSearch.noticeTimeEnd = this.formDataSearch.publishTime[1];
      }
      // 集采成果
      if (this.source === announcementPageSource.JCCG) {
        param.searchNoticeType = "100068JCCG";
      }
      // 集采方案
      if (this.source === announcementPageSource.JGFA) {
        param.searchNoticeType = "100068JGFA";
      }
      // 集采框架协议
      if (this.source === announcementPageSource.JCKJXY) {
        param.searchNoticeType = "100068JCKJXY";
      }
      // 物资集采目录
      if (this.source === announcementPageSource.WZJCML) {
        param.searchNoticeType = "100068WZJCML";
      }
      // 集采专家成员名单
      if (this.source === announcementPageSource.JCZJCYMD) {
        param.searchNoticeType = "100068JCZJCYMD";
      }
      // 采购管理制度
      if (this.source === announcementPageSource.CGGLZD) {
        param.searchNoticeType = "100068CGGLZD";
      }
      // 示范文本
      if (this.source === announcementPageSource.SFWB) {
        param.searchNoticeType = "100068SFWB";
      }
      // 内贸企业信息
      if (this.source === announcementPageSource.NMQYXX) {
        param.searchNoticeType = "100068NMQYXX";
      }
      // 获奖情况
      if (this.source === announcementPageSource.HJQK) {
        param.searchNoticeType = "100068HJQK";
      }
      // 获奖情况
      if (this.source === announcementPageSource.ZCFG) {
        param.searchNoticeType = "100068ZCFG";
      }
      // 制度流程
      if (this.source === announcementPageSource.ZDLC) {
        param.searchNoticeType = "100068ZDLC";
      }
      // 合同范本
      if (this.source === announcementPageSource.HTFB) {
        param.searchNoticeType = "100068HTFB";
      }
      // 知识管理
      if (this.source === announcementPageSource.ZSGL) {
        param.searchNoticeType = "100068ZSGL";
      }
      // 管理体系
      if (this.source === announcementPageSource.GLTX) {
        param.searchNoticeType = "100068GLTX";
      }
      // 行业网站
      if (this.source === announcementPageSource.HYWZ) {
        param.searchNoticeType = "100068HYWZ";
      }
      // 行业新闻
      if (this.source === announcementPageSource.HYXW) {
        param.searchNoticeType = "100068HYXW";
      }
      // 市场行情
      if (this.source === announcementPageSource.SCHQ) {
        param.searchNoticeType = "100068SCHQ";
      }
      // 价格信息
      if (this.source === announcementPageSource.JGXX) {
        param.searchNoticeType = "100068JGXX";
      }
      // 分析报告
      if (this.source === announcementPageSource.FXBG) {
        param.searchNoticeType = "100068FXBG";
      }
      // 供应链管理部总经理信箱
      if (this.source === announcementPageSource.GYLGLBZJLXX) {
        param.searchNoticeType = "100068GYLGLBZJLXX";
      }
      // 湖北供应商推荐
      if (this.source === announcementPageSource.supplierRecommend) {
        this.otherParams.textType = "100068JCCG";
      }
      // 海外集采价格专区
      if (this.source === announcementPageSource.overseasZone) {
        // 待定  暂时先传湖北供应商推荐的
        param.searchNoticeType = "100068HWJCJGZQ";
      }
      Object.assign(param, this.formDataSearch);
      this.$delete(param, "publishTime");
      this.callInterface(param).then(res => {
        if (res.data.code === "0") {
          this.tableData = res.data.data.rows.map(item => {
            item.title = item.noticeTitle ? item.noticeTitle : "";
            item.publishTime = item.noticeStartTime
              ? moment(item.noticeStartTime).format("YYYY-MM-DD HH:mm")
              : "";
            return item;
          });
          this.pageTotal = res.data.data.recordsTotal;
        }
      });
    },
    search(searchData) {
      this.pageNo = 1;
      this.formDataSearch = searchData;
      this.getNoticeList();
    },
    //查看
    check(row) {
      // 工作动态和通知公告
      this.$router.push({
        path: "/announcementDetail",
        query: {
          id: row.noticeId,
          noticeId: row.noticeId,
          source: this.source,
          type: row.type,
          activeIndex: this.$route.query.activeIndex
        }
      });
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      // 判断高亮行
      return { color: "#0089EF", cursor: "pointer" };
    },
    handleCheckAllChange(arr) {
      this.isSelection = arr.length !== 0;
    },
    handleCheckChange(arr) {
      this.isSelection = arr.length !== 0;
    },
    handleSelectionChange(arr) {
      this.isSelection = arr.length !== 0;
    }
  }
};
</script>

<style scoped lang="scss">
/deep/ .el-form-item__content {
  width: 149px;
}
</style>
